export const CREATE_PAYMENT = 'CREATE_PAYMENT'
export const DELETE_PAYMENT = 'DELETE_PAYMENT'
export const UPDATE_PAYMENT = 'UPDATE_PAYMENT'
export const VOID_PAYMENT = 'VOID_PAYMENT'
export const SET_UNSYNCED_PAYMENT_CARDREADER = 'SET_UNSYNCED_PAYMENT_CARDREADER'
export const UNSET_UNSYNCED_PAYMENT_CARDREADER = 'UNSET_UNSYNCED_PAYMENT_CARDREADER'
export const SET_UNSYNCED_PAYMENT_SERVER = 'SET_UNSYNCED_PAYMENT_SERVER'
export const UNSET_UNSYNCED_PAYMENT_SERVER = 'UNSET_UNSYNCED_PAYMENT_SERVER'
